// The repo's FIRST `React.lazy` — surfaces (T11 peek maps, T13 QE Map view, T14 TE map pane, T16
// Spatial Explorer) import `SpatialMapHost`/`SpatialMapLazy` from HERE, never `./SpatialMap`
// directly. That single dynamic `import('./SpatialMap')` is what keeps maplibre-gl + its CSS in
// their own Vite chunk (asserted by `scripts/assert-spatial-lazy-chunks.mjs`). The Suspense
// fallback uses `RandomDotmSpinner` (repo rule — never Loader2).

import { lazy, Suspense } from 'react';
import { RandomDotmSpinner } from '../../../../components/ui/RandomDotmSpinner';
import type { SpatialMap } from './SpatialMap';
import type { SpatialMapProps } from './spatialMapTypes';

export type {
  SpatialMapProps,
  SpatialMapFeature,
  SpatialMapViewport,
  SpatialProbeContext,
  PlanarTransform,
  SpatialMapLayerInput,
} from './spatialMapTypes';

export const SpatialMapLazy: React.LazyExoticComponent<typeof SpatialMap> = lazy(
  () => import('./SpatialMap'),
);

/** Suspense-wrapped host — the ergonomic entry point every surface renders. */
export function SpatialMapHost(props: SpatialMapProps) {
  return (
    <Suspense
      fallback={
        <div
          className="flex h-full w-full items-center justify-center"
          data-testid="spatial-map-loading"
        >
          <RandomDotmSpinner size={24} />
        </div>
      }
    >
      <SpatialMapLazy {...props} />
    </Suspense>
  );
}
